/*global Modernizr, google, theme_ramps, theme_trips, theme_entry_ramps, theme_exit_ramps, console */
/*jslint browser:true */

function setup_trip_planner_map(mapElement, tooltip) {
  'use strict';

  const mobile_map_expander = document.getElementById('map-mobile-layer'),
        mobile_map_shrinker = document.getElementById('map-mobile-layer-expand'),
        fieldClass = document.getElementById('trip-planner-form-class'),
        swapClass = {
          a: 2,
          b: 3,
          c: 4,
          d: 5,
          e: 6,
          f: 6
        },
        fieldAxles = document.getElementById('trip-planner-form-axles'),
        swapAxles = {
          2: 'a',
          3: 'b',
          4: 'c',
          5: 'd',
          6: 'e',
        },
        details_trigger = document.getElementById('trip-planner-details-trigger'),
        details_table = document.getElementById('trip-planner-details-content'),
        resetTrigger = document.getElementById('trip-planner-reset');
  let first_swap = false;

  mobile_map_expander.addEventListener('click', (e) => {
    mobile_map_expander.parentNode.classList.add('expanded');
  });

  mobile_map_shrinker.addEventListener('click', (e) => {
    mobile_map_expander.parentNode.classList.remove('expanded');
  });

  fieldClass.addEventListener('change', (e) => {
    if(first_swap) {
      return;
    }

    fieldAxles.value = swapClass[fieldClass.value];
    first_swap = true;
  });

  fieldAxles.addEventListener('change', (e) => {
    if(first_swap) {
      return;
    }

    fieldClass.value = swapAxles[fieldAxles.value];
    first_swap = true;
  });

  resetTrigger.addEventListener('click', (e) => {
    e.preventDefault();
    first_swap = false;
  });

  details_trigger.addEventListener('click', (e) => {
    e.preventDefault();

    if(details_trigger.classList.contains('open')) {
      details_trigger.classList.remove('open');
      details_trigger.setAttribute('aria-expanded', 'false');
      details_table.classList.remove('open');
    } else {
      details_trigger.classList.add('open');
      details_trigger.setAttribute('aria-expanded', 'true');
      details_table.classList.add('open');
    }
  });

  setup_trip_planner_common_trips(mapElement, tooltip);
  setup_trip_planner_custom_trips(mapElement, tooltip);
}

function setup_trip_planner_common_trips(mapElement, tooltip) {
  'use strict';

  const innerMap = mapElement.innerMap,
        plazaMarkers = mapElement.querySelectorAll('.theme-marker.marker-type-plaza'),
        rampMarkers = mapElement.querySelectorAll('.theme-marker.marker-type-ramp'),
        tabContent = document.getElementById('trip-planner-trips-content'),
        fieldTrip = document.getElementById('trip-planner-form-common-trip'),
        fieldClassContainer = document.getElementById('trip-planner-form-class-container'),
        fieldClass = document.getElementById('trip-planner-form-class'),
        fieldAxlesContainer = document.getElementById('trip-planner-form-axles-container'),
        fieldAxles = document.getElementById('trip-planner-form-axles'),
        buttonGrid = document.getElementById('trip-planner-button-grid'),
        resetTrigger = document.getElementById('trip-planner-reset');

  const updateSidebar = () => {
    const selectedTrip = fieldTrip.value;

    if(selectedTrip === '') {
      buttonGrid.classList.add('hidden');
      sh130_reset_trip_details();
      return;
    } else {
      buttonGrid.classList.remove('hidden');
    }

    const trip = theme_trips.find((trip) => {
            return trip.id === parseInt(selectedTrip);
          }),
          vehicle_class = fieldClass.value,
          vehicle_axles = fieldAxles.value,
          entry_ramp = theme_ramps.find((ramp) => {
            return ramp.id === parseInt(trip.start_id);
          }),
          exit_ramp = theme_ramps.find((ramp) => {
            return ramp.id === parseInt(trip.end_id);
          });

    if(trip.requires.includes('classes')) {
      fieldClassContainer.classList.remove('hidden');
    } else {
      fieldClassContainer.classList.add('hidden');
    }

    if(trip.requires.includes('axles')) {
      fieldAxlesContainer.classList.remove('hidden');
    } else {
      fieldAxlesContainer.classList.add('hidden');
    }

    sh130_build_trip(entry_ramp, exit_ramp, vehicle_class, vehicle_axles);
  };

  const updateMap = () => {
    const bounds = new google.maps.LatLngBounds(),
          selectedTrip = fieldTrip.value;

    var trip = {
          start: '',
          end: ''
        },
        entry_ramp = {
          order: 0
        },
        exit_ramp = {
          order: 0
        },
        shown_markers = 0;

    if(selectedTrip !== '') {
      trip = theme_trips.find((trip) => {
        return trip.id === parseInt(selectedTrip);
      });

      entry_ramp = theme_ramps.find((ramp) => {
        return ramp.id === trip.start_id;
      });

      exit_ramp = theme_ramps.find((ramp) => {
        return ramp.id === trip.end_id;
      });
    }

    // Show/Hide markers
    rampMarkers.forEach((marker) => {
      marker.classList.remove('selected-entry', 'selected-exit');

      if(selectedTrip === '') {
        marker.classList.add('hidden');
        return;
      }

      if(marker.getAttribute('data-slug') !== trip.start && marker.getAttribute('data-slug') !== trip.end) {
        marker.classList.add('hidden');
        return;
      }

      if(marker.getAttribute('data-slug') === trip.start) {
        marker.classList.add('selected-entry');
      }

      if(marker.getAttribute('data-slug') === trip.end) {
        marker.classList.add('selected-exit');
      }

      bounds.extend(marker.position);
      marker.classList.remove('hidden');
      shown_markers++;
    });

    plazaMarkers.forEach((marker) => {
      if(selectedTrip === '') {
        marker.classList.add('hidden');
        return;
      }

      var start_order = entry_ramp.order,
          end_order = exit_ramp.order;

      if(start_order > end_order) {
        start_order = exit_ramp.order;
        end_order = entry_ramp.order;
      }

      if(parseInt(marker.getAttribute('data-order')) < start_order || parseInt(marker.getAttribute('data-order')) > end_order) {
        marker.classList.add('hidden');
        return;
      }

      marker.classList.remove('hidden');
    });

    // Fit map to markers
    if(shown_markers > 0) {
      innerMap.fitBounds(bounds);
    } else {
      innerMap.setCenter({lat: 30.152760531461226, lng: -97.7267314439935});
      innerMap.setZoom(9.3);
    }
  };

  const resetMap = (e) => {
    e.preventDefault();

    fieldTrip.value = '';
    fieldClass.value = 'a';
    fieldAxles.value = '2';

    fieldClassContainer.classList.remove('hidden');
    fieldAxlesContainer.classList.add('hidden');

    updateMap();
    updateSidebar();

    if(e.pointerId === -1) {
      fieldTrip.focus();
    } else {
      tabContent.focus();
    }
  };

  tabContent.addEventListener('tab-opened', (e) => {
    mapElement.setAttribute('data-tab', 'common');

    updateMap();
    updateSidebar();
  });
  fieldTrip.addEventListener('change', (e) => {
    updateMap();
    updateSidebar();
  });
  fieldClass.addEventListener('change', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      updateSidebar(e);
    }
  });
  fieldAxles.addEventListener('change', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      updateSidebar(e);
    }
  });

  resetTrigger.addEventListener('click', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      resetMap(e);
    }
  });

  updateMap();
  updateSidebar();
}

function setup_trip_planner_custom_trips(mapElement, tooltip) {
  'use strict';

  const innerMap = mapElement.innerMap,
        plazaMarkers = mapElement.querySelectorAll('.theme-marker.marker-type-plaza'),
        rampMarkers = mapElement.querySelectorAll('.theme-marker.marker-type-ramp'),
        tabContent = document.getElementById('trip-planner-custom-content'),
        fieldEntry = document.getElementById('trip-planner-form-custom-entry'),
        fieldExit = document.getElementById('trip-planner-form-custom-exit'),
        fieldClassContainer = document.getElementById('trip-planner-form-class-container'),
        fieldClass = document.getElementById('trip-planner-form-class'),
        fieldAxlesContainer = document.getElementById('trip-planner-form-axles-container'),
        fieldAxles = document.getElementById('trip-planner-form-axles'),
        buttonGrid = document.getElementById('trip-planner-button-grid'),
        resetTrigger = document.getElementById('trip-planner-reset');

  const updateSidebar = () => {
    const form_entry = fieldEntry.value,
          form_exit = fieldExit.value,
          vehicle_class = fieldClass.value,
          vehicle_axles = fieldAxles.value;

    var selectedEntryRamp, entry_direction,
        selectedExitRamp, exit_direction,
        entry_ramp, exit_ramp;

    // Find entry ramp
    if(form_entry !== '') {
      [selectedEntryRamp, entry_direction] = form_entry.split('_');
      entry_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedEntryRamp);
      });
    }

    // Find exit ramp
    if(form_exit !== '') {
      [selectedExitRamp, exit_direction] = form_exit.split('_');
      exit_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedExitRamp);
      });
    }

    // If no field for both ramps, clear sidebar details
    if(typeof entry_ramp === 'undefined' && typeof exit_ramp === 'undefined') {
      buttonGrid.classList.add('hidden');
      sh130_reset_trip_details();
      return;
    }

    buttonGrid.classList.remove('hidden');

    // If no field for both ramps, clear sidebar details
    if(typeof entry_ramp === 'undefined' || typeof exit_ramp === 'undefined') {
      sh130_reset_trip_details();
      return;
    }

    if(entry_ramp.rate_type === 'classes' || exit_ramp.rate_type === 'classes') {
      fieldClassContainer.classList.remove('hidden');
    } else {
      fieldClassContainer.classList.add('hidden');
    }

    if(entry_ramp.rate_type === 'axles' || exit_ramp.rate_type === 'axles') {
      fieldAxlesContainer.classList.remove('hidden');
    } else {
      fieldAxlesContainer.classList.add('hidden');
    }

    sh130_build_trip(entry_ramp, exit_ramp, vehicle_class, vehicle_axles);
  };

  const updateMap = () => {
    const bounds = new google.maps.LatLngBounds(),
          form_entry = fieldEntry.value,
          form_exit = fieldExit.value;

    var selectedEntryRamp = '',
        entry_direction = '',
        selectedExitRamp = '',
        exit_direction = '',
        entry_ramp = '',
        exit_ramp = '';

    // Find entry ramp
    if(form_entry !== '') {
      [selectedEntryRamp, entry_direction] = form_entry.split('_');
      entry_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedEntryRamp);
      });
    }

    // Find exit ramp
    if(form_exit !== '') {
      [selectedExitRamp, exit_direction] = form_exit.split('_');
      exit_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedExitRamp);
      });
    }

    mapElement.setAttribute('data-ramp-entry', selectedEntryRamp);
    mapElement.setAttribute('data-ramp-exit', selectedExitRamp);

    // Show/Hide markers
    rampMarkers.forEach((marker) => {
      var is_selected = false;
      marker.classList.remove('selected-entry', 'selected-exit');

      // If nothing is selected at all, show all markers
      if(entry_ramp === '' && exit_ramp === '') {
        bounds.extend(marker.position);
        marker.classList.remove('hidden');
        return;
      }

      // Check if we have an entry ramp
      if(entry_ramp !== '') {
        // Check if this marker is the entry ramp
        if(entry_ramp.slug === marker.getAttribute('data-slug')) {
          is_selected = true;
          marker.classList.add('selected-entry');
        // Check if this marker is the opposite direction from where we enter
        } else if((entry_direction === 'sb' && entry_ramp.order > parseInt(marker.getAttribute('data-order'))) || (entry_direction === 'nb' && entry_ramp.order < parseInt(marker.getAttribute('data-order')))) {
          marker.classList.add('hidden');
          return;
        }
      }

      // Check if we have an exit ramp
      if(exit_ramp !== '') {
        // Check if this marker is the exit ramp
        if(exit_ramp.slug === marker.getAttribute('data-slug')) {
          is_selected = true;
          marker.classList.add('selected-exit');
        // Check if this marker is the opposite direction from where we exit
        } else if((exit_direction === 'sb' && exit_ramp.order < parseInt(marker.getAttribute('data-order'))) || (exit_direction === 'nb' && exit_ramp.order > parseInt(marker.getAttribute('data-order')))) {
          marker.classList.add('hidden');
          return;
        }
      }

      // Marker isn't being hidden and not selected, make sure it has this direction exit
      if(!is_selected) {
        // If we have an entry and exit ramp and this marker isn't one of them, hide the marker
        if(entry_ramp !== '' && exit_ramp !== '') {
          marker.classList.add('hidden');
          return;
        }

        if(entry_ramp !== '' && exit_ramp === '') {
          let marker_ramp = theme_ramps.find((ramp) => {
            return ramp.slug === marker.getAttribute('data-slug') && ramp.directions[entry_direction + '_exit'] !== 'na';
          });

          if(!marker_ramp) {
            marker.classList.add('hidden');
            return;
          }
        }

        if(entry_ramp === '' && exit_ramp !== '') {
          let marker_ramp = theme_ramps.find((ramp) => {
            return ramp.slug === marker.getAttribute('data-slug') && ramp.directions[exit_direction + '_entry'] !== 'na';
          });

          if(!marker_ramp) {
            marker.classList.add('hidden');
            return;
          }
        }
      }

      bounds.extend(marker.position);
      marker.classList.remove('hidden');
    });

    // Update plaza markers
    plazaMarkers.forEach((marker) => {
      if(typeof entry_ramp === 'undefined' && typeof exit_ramp === 'undefined') {
        bounds.extend(marker.position);
        marker.classList.remove('hidden');
        return;
      }

      // Check if we have an entry ramp
      if(typeof entry_ramp !== 'undefined') {
        if((entry_direction === 'sb' && entry_ramp.order > parseInt(marker.getAttribute('data-order'))) || (entry_direction === 'nb' && entry_ramp.order < parseInt(marker.getAttribute('data-order')))) {
          marker.classList.add('hidden');
          return;
        }
      }

      // Check if we have an exit ramp
      if(typeof exit_ramp !== 'undefined') {
        if((exit_direction === 'sb' && exit_ramp.order < parseInt(marker.getAttribute('data-order'))) || (exit_direction === 'nb' && exit_ramp.order > parseInt(marker.getAttribute('data-order')))) {
          marker.classList.add('hidden');
          return;
        }
      }

      marker.classList.remove('hidden');
    });

    // Fit map to markers
    innerMap.fitBounds(bounds);
  };

  const updateEntryRamps = () => {
    const form_entry = fieldEntry.value,
          form_entry_options = fieldEntry.querySelectorAll('option'),
          form_exit = fieldExit.value,
          vehicle_class = fieldClass.value,
          vehicle_axles = fieldAxles.value;

    var selectedExitRamp = '',
        exit_direction = '',
        exit_ramp = '';

    // Find exit ramp
    if(form_exit !== '') {
      [selectedExitRamp, exit_direction] = form_exit.split('_');
      exit_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedExitRamp);
      });
    }

    form_entry_options.forEach((option) => {
      if(option.getAttribute('value') === '') {
        return;
      }

      option.remove();
    });

    theme_entry_ramps.forEach((ramp) => {
      let [option_ramp_id, option_direction] = ramp[0].split('_'),
          option_ramp = theme_ramps.find((ramp) => {
            return ramp.id === parseInt(option_ramp_id);
          });

      if(exit_ramp !== '' && (option_direction !== exit_direction || exit_ramp.slug === option_ramp.slug || (exit_direction === 'sb' && exit_ramp.order < option_ramp.order) || (exit_direction === 'nb' && exit_ramp.order > option_ramp.order))) {
        return;
      }

      let option = document.createElement('option');
      option.setAttribute('value', ramp[0]);
      option.textContent = ramp[1];

      if(ramp[0] === form_entry) {
        option.selected = true;
      }

      fieldEntry.appendChild(option);
    });
  };

  const updateExitRamps = () => {
    const form_entry = fieldEntry.value,
          form_exit = fieldExit.value,
          form_exit_options = fieldExit.querySelectorAll('option'),
          vehicle_class = fieldClass.value,
          vehicle_axles = fieldAxles.value;

    var selectedEntryRamp = '',
        entry_direction = '',
        entry_ramp = '';

    // Find entry ramp
    if(form_entry !== '') {
      [selectedEntryRamp, entry_direction] = form_entry.split('_');
      entry_ramp = theme_ramps.find((ramp) => {
        return ramp.id === parseInt(selectedEntryRamp);
      });
    }

    form_exit_options.forEach((option) => {
      if(option.getAttribute('value') === '') {
        return;
      }

      option.remove();
    });

    theme_exit_ramps.forEach((ramp) => {
      let [option_ramp_id, option_direction] = ramp[0].split('_'),
          option_ramp = theme_ramps.find((ramp) => {
            return ramp.id === parseInt(option_ramp_id);
          });

      if(entry_ramp !== '' && (option_direction !== entry_direction || entry_ramp.slug === option_ramp.slug ||  (entry_direction === 'sb' && entry_ramp.order > option_ramp.order) || (entry_direction === 'nb' && entry_ramp.order < option_ramp.order))) {
        return;
      }

      let option = document.createElement('option');
      option.setAttribute('value', ramp[0]);
      option.textContent = ramp[1];

      if(ramp[0] === form_exit) {
        option.selected = true;
      }

      fieldExit.appendChild(option);
    });
  };

  const resetMap = (e) => {
    e.preventDefault();

    fieldEntry.value = '';
    fieldExit.value = '';
    fieldClass.value = 'a';
    fieldAxles.value = '2';

    fieldClassContainer.classList.remove('hidden');
    fieldAxlesContainer.classList.add('hidden');

    var popup_container = mapElement.querySelector('.popup-container');
    if(popup_container) {
      var reset_button = popup_container.querySelector('.trip-planner-buttons-reset');
      if(reset_button) {
        reset_button.classList.remove('show');
      }
    }

    updateMap();
    updateSidebar();

    if(e.pointerId === -1) {
      fieldEntry.focus();
    } else {
      tabContent.focus();
    }
  };

  const actionEnter = (button) => {
    var button_ramp = '',
        button_direction = '';

    // Get this button ramp and specific direction
    [button_ramp, button_direction] = button.getAttribute('data-ramp').split('_');

    // Find the ramps that match this slug
    var found_ramps = theme_ramps.filter((ramp) => {
      return ramp.slug === button_ramp;
    });

    // Set the ramp that has this direction entry
    found_ramps.forEach((ramp) => {
      if(ramp.directions[button_direction + '_entry'] !== 'na' && ramp.directions[button_direction + '_entry'] !== '') {
        fieldEntry.value = ramp.id + '_' + button_direction;
      }
    });

    updateMap();
    updateSidebar();
  };

  const actionExit = (button) => {
    var form_entry = fieldEntry.value,
        selectedEntryRamp = '',
        entry_direction = '',
        button_ramp = button.getAttribute('data-ramp');

    // Get the entry value to know direction
    [selectedEntryRamp, entry_direction] = form_entry.split('_');

    // Find ramps that match slug
    var found_ramps = theme_ramps.filter((ramp) => {
      return ramp.slug === button_ramp;
    });

    // Set the one that has this direction exit
    found_ramps.forEach((ramp) => {
      if(ramp.directions[entry_direction + '_exit'] !== 'na') {
        fieldExit.value = ramp.id + '_' + entry_direction;
      }
    });

    updateMap();
    updateSidebar();
  };

  mapElement.addEventListener('click', (e) => {
    var action_button = e.target.closest('.theme-button');

    if(!action_button || !action_button.hasAttribute('data-action')) {
      return;
    }

    e.preventDefault();

    switch(action_button.getAttribute('data-action')) {
      case 'ramp_enter':
        tooltip.setMap();
        actionEnter(action_button);
        updateExitRamps();
        break;
      case 'ramp_exit':
        tooltip.setMap();
        actionExit(action_button);
        updateEntryRamps();
        break;
      case 'reset':
        resetMap(e);
        updateEntryRamps();
        updateExitRamps();
        break;
    }
  });

  rampMarkers.forEach((marker) => {
    marker.addEventListener('marker-clicked', (e) => {
      var marker = e.target,
          map_entry_id = mapElement.getAttribute('data-ramp-entry'),
          map_exit_id = mapElement.getAttribute('data-ramp-exit'),
          marker_slug = marker.getAttribute('data-slug'),
          ramp = theme_ramps.filter((ramp) => {
            return (ramp.id === parseInt(map_entry_id) || ramp.id === parseInt(map_exit_id)) && ramp.slug === marker_slug;
          }),
          popup_container = mapElement.querySelector('.popup-container');

      // If this marker is the entry or exit ramp, only show reset trip
      if(ramp.length > 0) {
        popup_container.querySelector('.trip-planner-buttons-entry').classList.add('hidden');
        popup_container.querySelector('.trip-planner-buttons-exit').classList.add('hidden');
        popup_container.querySelector('.trip-planner-buttons-reset').classList.add('show');
        return;
      }

      // If exit ramp is set, limit what entry button shows
      if(map_exit_id !== '' && map_entry_id === '') {
        let form_exit = fieldExit.value,
            selectedExitRamp = '',
            exit_direction = '',
            exit_ramp = '';

        // Find exit ramp
        if(form_exit !== '') {
          [selectedExitRamp, exit_direction] = form_exit.split('_');
          exit_ramp = theme_ramps.find((ramp) => {
            return ramp.id === parseInt(selectedExitRamp);
          });
        }

        var wrong_direction_button = popup_container.querySelector('.trip-planner-buttons-entry .theme-button[data-ramp="' + marker.getAttribute('data-slug') + '_' + ((exit_direction === 'nb')?'sb':'nb') + '"]');
        if(wrong_direction_button) {
          wrong_direction_button.classList.add('hidden');
        }
      }
    });
  });

  tabContent.addEventListener('tab-opened', (e) => {
    mapElement.setAttribute('data-tab', 'custom');

    updateMap();
    updateSidebar();
  });
  fieldEntry.addEventListener('change', (e) => {
    updateExitRamps();
    updateMap();
    updateSidebar();
  });
  fieldExit.addEventListener('change', (e) => {
    updateEntryRamps();
    updateMap();
    updateSidebar();
  });
  fieldClass.addEventListener('change', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      updateSidebar(e);
    }
  });
  fieldAxles.addEventListener('change', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      updateSidebar(e);
    }
  });

  resetTrigger.addEventListener('click', (e) => {
    if(tabContent.classList.contains('tab-current')) {
      resetMap(e);
      updateEntryRamps();
      updateExitRamps();
    }
  });
}

function sh130_build_trip(entry_ramp, exit_ramp, vehicle_class, vehicle_axles) {
  'use strict';

  var direction = 'nb',
      segment,
      builtTrip = {
        price_toll: 0,
        price_pbm: 0,
        details: []
      };

  // Get ramps between 2 points, and order them in the direction of travel (default is North to South)
  if(entry_ramp.order < exit_ramp.order) {
    direction = 'sb';

    segment = theme_ramps.slice(entry_ramp.order, (exit_ramp.order));
  } else {
    segment = theme_ramps.slice(exit_ramp.order, (entry_ramp.order)).reverse();
  }

  // Add starting ramp (ignoring if that ramp is not toll)
  if(entry_ramp.directions[direction + '_entry'] === 'toll') {
    builtTrip.price_toll = sh130_bcadd(builtTrip.price_toll, entry_ramp.rates[((entry_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag']);
    builtTrip.price_pbm = sh130_bcadd(builtTrip.price_pbm, entry_ramp.rates[((entry_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']);
    builtTrip.details.push({
      title: entry_ramp.name,
      price_toll: entry_ramp.rates[((entry_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag'],
      price_pbm: entry_ramp.rates[((entry_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']
    });
  } else {
    builtTrip.details.push({
      title: entry_ramp.name,
      price_toll: 0,
      price_pbm: 0
    });
  }

  segment.forEach((ramp) => {
    // Add each plaza between the 2 ramps, only if they charge in that direction
    if(ramp.toll_type === 'plaza' && ramp.directions.includes(direction)) {
      builtTrip.price_toll = sh130_bcadd(builtTrip.price_toll, ramp.rates[((ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag']);
      builtTrip.price_pbm = sh130_bcadd(builtTrip.price_pbm, ramp.rates[((ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']);
      builtTrip.details.push({
        title: ramp.name,
        price_toll: ramp.rates[((ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag'],
        price_pbm: ramp.rates[((ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']
      });
    }
  });

  // Add ending ramp (ignoring if that ramp is not toll)
  if(exit_ramp.directions[direction + '_exit'] === 'toll') {
    builtTrip.price_toll = sh130_bcadd(builtTrip.price_toll, exit_ramp.rates[((exit_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag']);
    builtTrip.price_pbm = sh130_bcadd(builtTrip.price_pbm, exit_ramp.rates[((exit_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']);
    builtTrip.details.push({
      title: exit_ramp.name,
      price_toll: exit_ramp.rates[((exit_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['tag'],
      price_pbm: exit_ramp.rates[((exit_ramp.rate_type === 'axles')?'axle_' + vehicle_axles:'class_' + vehicle_class)]['pbm']
    });
  } else {
    builtTrip.details.push({
      title: exit_ramp.name,
      price_toll: 0,
      price_pbm: 0
    });
  }

  sh130_update_trip_details(builtTrip);
}

function sh130_reset_trip_details() {
  'use strict';

  const details_prices = document.getElementById('trip-planner-details-prices'),
        details_trigger = document.getElementById('trip-planner-details-trigger'),
        details_table = document.getElementById('trip-planner-details-content'),
        details_table_body = details_table.querySelector('tbody');

  details_prices.classList.add('hidden');
  details_trigger.classList.add('hidden');
  details_table_body.innerHTML = '';
  details_table.classList.add('hidden');
}

function sh130_update_trip_details(trip) {
  'use strict';

  const details_prices = document.getElementById('trip-planner-details-prices'),
        details_prices_tag_dollar = details_prices.querySelector('.price-tag-dollars'),
        details_prices_tag_cents = details_prices.querySelector('.price-tag-cents'),
        details_prices_pbm_dollar = details_prices.querySelector('.price-pbm-dollars'),
        details_prices_pbm_cents = details_prices.querySelector('.price-pbm-cents'),
        details_trigger = document.getElementById('trip-planner-details-trigger'),
        details_table = document.getElementById('trip-planner-details-content'),
        details_table_body = details_table.querySelector('tbody');

  var [trip_price_tag_dollars, trip_price_tag_cents] = trip.price_toll.toFixed(2).toString().split('.'),
      [trip_price_pbm_dollars, trip_price_pbm_cents] = trip.price_pbm.toFixed(2).toString().split('.');

  details_prices_tag_dollar.textContent = trip_price_tag_dollars;
  details_prices_tag_cents.textContent = trip_price_tag_cents;
  details_prices_pbm_dollar.textContent = trip_price_pbm_dollars;
  details_prices_pbm_cents.textContent = trip_price_pbm_cents;

  details_prices.classList.remove('hidden');
  details_trigger.classList.remove('hidden');

  details_table_body.innerHTML = '';

  trip.details.forEach((ramp) => {
    let tr = document.createElement('tr'),
        th_name = document.createElement('th'),
        td_price_tag = document.createElement('td'),
        td_price_pbm = document.createElement('td');

    th_name.setAttribute('scope', 'row');
    th_name.textContent = ramp.title;

    td_price_tag.classList.add('no-wrap', 'align-center');
    td_price_tag.textContent = '$' + ((ramp.price_toll !== 0)?parseFloat(ramp.price_toll).toFixed(2):0);

    td_price_pbm.classList.add('no-wrap', 'align-center');
    td_price_pbm.textContent = '$' + ((ramp.price_toll !== 0)?parseFloat(ramp.price_pbm).toFixed(2):0);

    tr.append(th_name, td_price_tag, td_price_pbm);

    details_table_body.append(tr);
  });

  details_table.classList.remove('hidden');
}

function sh130_bcadd(a, b) {
  'use strict';

  return (Math.round(a * 100) + Math.round(b * 100)) / 100;
}
